import { isNitroOrLocalEnvironment } from 'module/helpers/environment-type';
import { API_HOST } from 'config/environment';
import { HttpClient } from '../http-client';
import {
  AccountInitialData,
  AccountMeta,
  AccountSignUpPayload,
  AccountSignUpResponse,
  AccountSignUpThroughGooglePayload,
  Currency,
  CurrencyMappingList,
  ForgotAccountPayload,
  IsDomainExistsPayload,
  IsDomainExistsResponse,
} from './types';

export class AccountHttpClient extends HttpClient {
  public getMeta = () =>
    this.get<AccountMeta>('/accounts/get-meta', { withCredentials: false });
  public forgotAccount = (payload: ForgotAccountPayload) => {
    return this.post(
      'https://admin.api.rocketlane.com/api/v1/accounts/forgot',
      {
        emailId: payload.email,
      },
    );
  };
  public resendAccountActivation = () => {
    return this.post('/accounts/activate/resend');
  };
  public signUp = ({
    token,
    ...payload
  }: AccountSignUpPayload): Promise<AccountSignUpResponse> => {
    return this.put('/accounts/sign-up', payload, { params: { token } });
  };
  public signUpThroughGoogle = ({
    ...payload
  }: AccountSignUpThroughGooglePayload): Promise<AccountSignUpResponse> => {
    return this.post(
      `${isNitroOrLocalEnvironment() ? API_HOST : 'https://admin.api.rocketlane.com'}/api/v1/accounts/signup-google`,
      payload,
    );
  };
  public isDomainExists = ({
    token,
    ...payload
  }: IsDomainExistsPayload): Promise<IsDomainExistsResponse> => {
    if (payload.throughGoogleAuth) {
      return this.post(
        'https://admin.api.rocketlane.com/api/v1/accounts/domain',
        {
          domainName: payload.domainName,
        },
        {
          params: { token },
        },
      );
    }

    return this.post(
      '/accounts/domain',
      { domainName: payload.domainName },
      { params: { token } },
    );
  };
  public getCurrencyList = async (): Promise<Currency[]> =>
    this.get('/accounts/currencies');

  public getCurrencyMappingList = async (): Promise<CurrencyMappingList> =>
    this.get('/accounts/currency-mapping');
  public getAccountInitData = async (): Promise<AccountInitialData> =>
    this.get('/home/init');
}
